module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Cap-050967281efbc60e1cba891df5d23e4d.svg";